import { makeStyles } from "@material-ui/core/styles";
import { globalTheme } from "style/globalTheme";

export const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "60rem",
    padding: "2rem",
    paddingBottom: "5rem",
    "& div[class^=MuiTabs-flexContainer]": {
      margin: "0 auto 3rem auto",
      display: "flex",
      justifyContent: "center",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1rem",
      paddingBottom: "5rem",
      "& div[class^=MuiTabs-flexContainer]": {
        margin: "0 auto 2rem auto",
      },
    },
  },
  gridContainer: {
    marginBottom: "3rem",
    "& .super-app-theme--header": {
      backgroundColor: globalTheme.palette.lightBg.main,
      borderBottom: "1px solid",
      borderColor: globalTheme.palette.midlightBg.main,
      fontWeight: "900 !important",
      height: "55px",
    },
    "& .MuiDataGrid-footerContainer": {
      marginBottom: "1rem",
    },
  },
  goBackButton: {
    color: "#424242",
    textTransform: "none",
    fontSize: "1rem",
    padding: "8px 16px",
    borderRadius: "4px",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

